import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider, } from "@material-ui/core";

const VcardPreview = ({ contact, numbers }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });
    const [selectedQueue, setSelectedQueue] = useState("");
    const [selectedUser, setSelectedUser] = useState("");
    const [queueUsers, setQueueUsers] = useState([]);
    const [loadingQueueUsers, setLoadingQueueUsers] = useState(false);
    const availableQueues = Array.isArray(user?.queues) ? user.queues : [];

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    let contactObj = {
                        name: contact,
                        // number: numbers.replace(/\D/g, ""),
                        number: numbers !== undefined && numbers.replace(/\D/g, ""),
                        email: ""
                    }
                    const { data } = await api.post("/contact", contactObj);
                    setContact(data)

                } catch (err) {
                    console.log(err)
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [contact, numbers]);

    useEffect(() => {
        if (!selectedQueue) {
            setQueueUsers([]);
            setLoadingQueueUsers(false);
            setSelectedUser("");
            return;
        }

        const fetchQueueUsers = async () => {
            setLoadingQueueUsers(true);
            try {
                const { data } = await api.get("/users/", {
                    params: {
                        searchParam: "",
                        queueId: selectedQueue,
                    },
                });
                setQueueUsers(Array.isArray(data?.users) ? data.users : []);
            } catch (err) {
                setQueueUsers([]);
                toastError(err);
            } finally {
                setLoadingQueueUsers(false);
            }
        };

        fetchQueueUsers();
    }, [selectedQueue]);

    const handleNewChat = async () => {
        if (!selectedQueue || !selectedUser) {
            return;
        }

        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: Number(selectedUser),
                queueId: Number(selectedQueue),
                status: "open",
            });
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
            }}>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Avatar src={selectedContact.profilePicUrl} />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
                            {selectedContact.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            disabled={availableQueues.length === 0}
                        >
                            <InputLabel>Fila</InputLabel>
                            <Select
                                value={selectedQueue}
                                onChange={e => {
                                    setSelectedQueue(e.target.value);
                                    setSelectedUser("");
                                }}
                                label="Fila"
                            >
                                <MenuItem value="" disabled>
                                    {availableQueues.length ? "Selecione uma fila" : "Nenhuma fila disponivel"}
                                </MenuItem>
                                {availableQueues.map(queue => (
                                    <MenuItem key={queue.id} value={String(queue.id)}>
                                        {queue.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            disabled={!selectedQueue || loadingQueueUsers}
                        >
                            <InputLabel>Atendente</InputLabel>
                            <Select
                                value={selectedUser}
                                onChange={e => setSelectedUser(e.target.value)}
                                label="Atendente"
                            >
                                <MenuItem value="" disabled>
                                    {loadingQueueUsers ? "Carregando atendentes..." : "Selecione um atendente"}
                                </MenuItem>
                                {queueUsers.map(queueUser => (
                                    <MenuItem key={queueUser.id} value={String(queueUser.id)}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%",
                                                gap: 8,
                                            }}
                                        >
                                            <span>{queueUser.name}</span>
                                            <span
                                                style={{
                                                    width: 16,
                                                    height: 16,
                                                    borderRadius: "50%",
                                                    backgroundColor: queueUser?.isOnline ? "#2e7d32" : "#d32f2f",
                                                    display: "inline-block",
                                                    flexShrink: 0,
                                                }}
                                            />
                                        </div>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!selectedContact.number || !selectedQueue || !selectedUser || loadingQueueUsers}
                        >Conversar</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;